import { render, staticRenderFns } from "./GestioneModuliQuickConnext.vue?vue&type=template&id=1bb327d4&"
import script from "./GestioneModuliQuickConnext.vue?vue&type=script&lang=js&"
export * from "./GestioneModuliQuickConnext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports